import { Link } from "gatsby"
import PropTypes from "prop-types"
import React, { useState, useEffect } from 'react';
import Cavaat from "../components/cavaat"
import { AnchorLink } from "gatsby-plugin-anchor-links";

const Header = ({ siteTitle,lang }) => {
  var UID = {
    _current: 0,
    getNew: function(){
      this._current++;
      return this._current;
    }
  };
  useEffect(() => {
    activeLink();
  });
  function activeLink() {
    var x = document.activeElement.tagName;
    if(x=='A'){
      const gl = document.getElementById('mobile-nav');
      const btn_state = document.getElementById('submenu-state');
      btn_state.classList.remove('submenu-state-off');
      btn_state.classList.add('submenu-state-on');
      gl.style.display='none';
    }
  }
  
  HTMLElement.prototype.pseudoStyle = function(element,prop,value){
    var _this = this;
    var _sheetId = "pseudoStyles";
    var _head = document.head || document.getElementsByTagName('head')[0];
    var _sheet = document.getElementById(_sheetId) || document.createElement('style');
    _sheet.id = _sheetId;
    var className = "pseudoStyle" + UID.getNew();
    
    _this.className +=  " "+className; 
    
    _sheet.innerHTML += " ."+className+":"+element+"{"+prop+":"+value+"}";
    _head.appendChild(_sheet);
    return this;
  };

function showMenu(){
  const gl = document.getElementById('mobile-nav');
 
  // const gl_m = document.getElementById('mobile-nav-menu');
  const btn_state = document.getElementById('submenu-state');
  if(btn_state.classList.contains('submenu-state-on')){
    btn_state.classList.remove('submenu-state-on');
    btn_state.classList.add('submenu-state-off');
    gl.style.display='block';
  
//    gl_m.style.display='block';
  }else{
    btn_state.classList.remove('submenu-state-off');
    btn_state.classList.add('submenu-state-on');
    gl.style.display='none';
  
   // gl_m.style.display='none';
  }
}



  if(lang==='en'){
  return(<header>
  <nav className="mobile-nav-menu" id="mobile-nav-menu">
   <div className="clearfix"> 
  <div className="logo"></div>
  <i className="submenu-state-on" id ="submenu-state" onClick={showMenu}></i>
  </div>
  <ul className="mobile-nav" id="mobile-nav">
        <li>
          <span>1</span>
          <AnchorLink
    to="/#section1" title="Executive Summary" className="stripped"
    stripHash />
           
        </li>
        <li>
        
          <span>2</span>
          <AnchorLink
    to="/#section2" title="Journalists' Killings in 2018 AND 2019: KEY FINDINGS" className="stripped"
    stripHash />
     <Cavaat gelement="submenu-1"></Cavaat>
          <div className="clearfix"></div>
          <ul className="submenu" id="submenu-1"> 
         
             <li>
             <AnchorLink
    to="/#killing-of-journalists" title="killings of Journalists occur in all regions" className="stripped"
    stripHash /> <Cavaat gelement="submenu-1"></Cavaat>
              </li>
             <li>
             <AnchorLink
    to="/#type-of-attacks" title="Types of Attacks" className="stripped"
    stripHash /></li>
             <li> <AnchorLink
    to="/#attacks-against-journalist-are-gendered" title="Attacks against Journalists are Gendered" className="stripped"
    stripHash />
               </li>
             <li>
             <AnchorLink
    to="/#gender-dimension-of-safety" title="Gender Dimension of Safety" className="stripped"
    stripHash /></li>
             <li>
             <AnchorLink
    to="/#tv-journalist-are-most-vunerable-to-attacks" title="TV Journalists are most vunerable to fatal attacks" className="stripped"
    stripHash />
               </li>
             <li>
             <AnchorLink
    to="/#local-journalist-remain-targets" title="Local journalists remain targets" className="stripped"
    stripHash />
              </li>
             <li>
             <AnchorLink
    to="/#freelance-and-staff-journalists" title="Freelance and Staff Journalists" className="stripped"
    stripHash />
              </li>
             <li>
             <AnchorLink
    to="/#most-journalist-were-killed-in-countries-with-no-armed-conflict" title="Most Journalists were killed in countries with no armed conflict" className="stripped"
    stripHash />
           </li>
           </ul>
        </li>
        <li>
          <span>3</span>
          <a href="#section3">STATES' RESPONSES</a> 
          <Cavaat gelement="submenu-2"></Cavaat>
          <div className="clearfix"></div> 
          <ul className="submenu" id="submenu-2">
         
             <li>
             <AnchorLink
    to="/#overview-of-responses-recieved" title="Overview of Responses Received in 2020" className="stripped"
    stripHash /> <Cavaat gelement="submenu-2"></Cavaat>
            </li>
             <li>
             <AnchorLink
    to="/#a-significant-increase-in-states-reaction-rate-in-2020" title="A significant increase in states' reaction rate in 2020" className="stripped"
    stripHash />
               </li>
             <li>
             <AnchorLink
    to="/#impunity-rate-drops-slightly-2020" title="Impunity rate drops slightly 2020" className="stripped"
    stripHash />
              </li>
             <li>
             <AnchorLink
    to="/#countries-reporting-on-measures-to-promote-saftety-of-journalists-and-combat-impunity" title="Countries reporting on measures to promote safety of journalists and combat impunity" className="stripped"
    stripHash />
              </li>
             <li>
             <AnchorLink
    to="/#ongoing-issues-in-the-safety-of-journalists" title="Ongoing issues in the safety of journalists" className="stripped"
    stripHash />
               </li>
             <li>
             <AnchorLink
    to="/#key-recent-text-adopted" title="Recent Key texts adopted" className="stripped"
    stripHash />
             </li>
           
           </ul>
        </li>
      </ul>
      <div className="clearfix"></div>
      <div className="translation-bar">
      <Link to="/" className="active">English</Link>
      <Link to="/fr">Français</Link>
      <Link to="/es">Español</Link>
      <Link to="/ru">Русский</Link>
      <Link to="/ar">العربية</Link>
      <Link to="/zh">中文</Link>
       
    </div>

  </nav>


    <nav className="main-nav">
      <div className="logo">

      </div>
  
      <ul>
        <li>
          <span>1</span>
          <AnchorLink
    to="/#section1" title="Executive Summary" className="stripped"
    stripHash />
           
        </li>
        <li>
          <span>2</span>
          <AnchorLink
    to="/#section2" title="Journalists' Killings in 2018 AND 2019: KEY FINDINGS" className="stripped"
    stripHash />
       
          <div className="clearfix"></div>
          <ul className="submenu"> 
             <li>
             <AnchorLink
    to="/#killing-of-journalists" title="killings of Journalists occur in all regions" className="stripped"
    stripHash />
              </li>
             <li>
             <AnchorLink
    to="/#type-of-attacks" title="Types of Attacks" className="stripped"
    stripHash /></li>
             <li> <AnchorLink
    to="/#attacks-against-journalist-are-gendered" title="Attacks against Journalists are Gendered" className="stripped"
    stripHash />
               </li>
             <li>
             <AnchorLink
    to="/#gender-dimension-of-safety" title="Gender Dimension of Safety" className="stripped"
    stripHash /></li>
             <li>
             <AnchorLink
    to="/#tv-journalist-are-most-vunerable-to-attacks" title="TV Journalists are most vunerable to fatal attacks" className="stripped"
    stripHash />
               </li>
             <li>
             <AnchorLink
    to="/#local-journalist-remain-targets" title="Local journalists remain targets" className="stripped"
    stripHash />
              </li>
             <li>
             <AnchorLink
    to="/#freelance-and-staff-journalists" title="Freelance and Staff Journalists" className="stripped"
    stripHash />
              </li>
             <li>
             <AnchorLink
    to="/#most-journalist-were-killed-in-countries-with-no-armed-conflict" title="Most Journalists were killed in countries with no armed conflict" className="stripped"
    stripHash />
           </li>
           </ul>
        </li>
        <li>
          <span>3</span>
          <a href="#section3">STATES' RESPONSES</a> 
          <div className="clearfix"></div> 
          <ul className="submenu">
             <li>
             <AnchorLink
    to="/#overview-of-responses-recieved" title="Overview of Responses Received in 2020" className="stripped"
    stripHash />
            </li>
             <li>
             <AnchorLink
    to="/#a-significant-increase-in-states-reaction-rate-in-2020" title="A significant increase in states' reaction rate in 2020" className="stripped"
    stripHash />
               </li>
             <li>
             <AnchorLink
    to="/#impunity-rate-drops-slightly-2020" title="Impunity rate drops slightly 2020" className="stripped"
    stripHash />
              </li>
             <li>
             <AnchorLink
    to="/#countries-reporting-on-measures-to-promote-saftety-of-journalists-and-combat-impunity" title="Countries reporting on measures to promote safety of journalists and combat impunity" className="stripped"
    stripHash />
              </li>
             <li>
             <AnchorLink
    to="/#ongoing-issues-in-the-safety-of-journalists" title="Ongoing issues in the safety of journalists" className="stripped"
    stripHash />
               </li>
             <li>
             <AnchorLink
    to="/#key-recent-text-adopted" title="Recent Key texts adopted" className="stripped"
    stripHash />
             </li>
           
           </ul>
        </li>
      </ul>
      <div className="translation-bar">
      <Link to="/" className="active">English</Link>
      <Link to="/fr">Français</Link>
      <Link to="/es">Español</Link>
      <Link to="/ru">Русский</Link>
      <Link to="/ar">العربية</Link>
      <Link to="/zh">中文</Link>
    </div>
    </nav>
    
  </header>)
  }
  //Arabic
  if(lang==='ar'){
    return(<header>
    <nav className="mobile-nav-menu" id="mobile-nav-menu">
     <div className="clearfix"> 
    <div className="logo"></div>
    <i className="submenu-state-on" id ="submenu-state" onClick={showMenu}></i>
    </div>
    <ul className="mobile-nav rtl" id="mobile-nav">
    <li>
           
           <a href="/ar/#section3">استجابة الدول</a> 
           <span>3</span>
           <Cavaat gelement="submenu-2"></Cavaat>
           <div className="clearfix"></div> 
           <ul className="submenu" id="submenu-2">
          
              <li>
              <AnchorLink
     to="/ar/#overview-of-responses-recieved" title="نظرة عامة حول الإجابات الواردة في عام 2020" className="stripped"
     stripHash /> <Cavaat gelement="submenu-2"></Cavaat>
             </li>
              <li>
              <AnchorLink
     to="/ar/#a-significant-increase-in-states-reaction-rate-in-2020" title="زيادة ملحوظة في نسبة الاستجابة في عام 2020" className="stripped"
     stripHash />
                </li>
              <li>
              <AnchorLink
     to="/ar/#impunity-rate-drops-slightly-2020" title="نسبة الإفلات من العقاب تشهد تراجعاً طفيفاً في عام 2020" className="stripped"
     stripHash />
               </li>
              <li>
              <AnchorLink
     to="/ar/#countries-reporting-on-measures-to-promote-saftety-of-journalists-and-combat-impunity" title="الدول التي أبلغت عن اتخاذ تدابير لتعزيز سلامة الصحفيين ومحاربة الإفلات من العقاب" className="stripped"
     stripHash />
               </li>
              <li>
              <AnchorLink
     to="/ar/#ongoing-issues-in-the-safety-of-journalists" title="قضايا مستمرة متعلقة بسلامة الصحفيين" className="stripped"
     stripHash />
                </li>
              <li>
              <AnchorLink
     to="/ar/#key-recent-text-adopted" title="أهم القرارات الصادرة مؤخراً حول سلامة الصحفيين" className="stripped"
     stripHash />
              </li>
            
            </ul>
         </li>
    <li>
          
           
            <AnchorLink
      to="/ar/#section2" title="جرائم قتل الصحفيين في عامي 2018 و 2019: الاستنتاجات الرئيسية" className="stripped"
      stripHash />
       <span>2</span>
       <Cavaat gelement="submenu-1"></Cavaat>
            <div className="clearfix"></div>
            <ul className="submenu" id="submenu-1"> 
           
               <li>
               <AnchorLink
      to="/ar/#killing-of-journalists" title="جرائم قتل الصحفيين التي تقع في كل المناطق" className="stripped"
      stripHash /> <Cavaat gelement="submenu-1"></Cavaat>
                </li>
               <li>
               <AnchorLink
      to="/ar/#type-of-attacks" title="أنواع الاعتداءات" className="stripped"
      stripHash /></li>
               <li> <AnchorLink
      to="/ar/#attacks-against-journalist-are-gendered" title="ارتباط الاعتداءات ضد الصحفيين بالنوع الاجتماعي" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/ar/#gender-dimension-of-safety" title="الأبعاد المتعلقة بالنوع الاجتماعي وعلاقتها بسلامة الصحفيين" className="stripped"
      stripHash /></li>
               <li>
               <AnchorLink
      to="/ar/#tv-journalist-are-most-vunerable-to-attacks" title="صحفيو التلفزيون الأكثر عرضةً لجرائم القتل" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/ar/#local-journalist-remain-targets" title="لا تزال جرائم القتل تستهدف الصحفيين المحليين بشكل رئيسي" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/ar/#freelance-and-staff-journalists" title="الصحفيون المستقلون والعاملون في المؤسسات الإعلامية" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/ar/#most-journalist-were-killed-in-countries-with-no-armed-conflict" title="معظم الضحايا قتلوا في بلدان لا تشهد نزاعات مسلحة" className="stripped"
      stripHash />
             </li>
             </ul>
          </li>

          <li>
            
            <AnchorLink
      to="/ar/#section1" dir="RTL" title="الملخص التنفيذي" className="stripped"
    
      stripHash />
             <span>1</span>
          </li>
         
          </ul>
        <div className="clearfix"></div>
        <div className="translation-bar">
      <Link to="/">English</Link>
      <Link to="/fr">Français</Link>
      <Link to="/es">Español</Link>
      <Link to="/ru">Русский</Link>
      <Link to="/ar" className="active">العربية</Link>
      <Link to="/zh">中文</Link>
      </div>
  
    </nav>
  
  
      <nav className="main-nav">
        <div className="logo">
  
        </div>
    
        <ul class="rtl">
        <li>
           
           <a href="#section3">استجابة الدول</a> 
           <span>3</span>
           <div className="clearfix"></div> 
           <ul className="submenu">
              <li>
              <AnchorLink
     to="/ar/#overview-of-responses-recieved" title="نظرة عامة حول الإجابات الواردة في عام 2020
     " className="stripped"
     stripHash />
             </li>
              <li>
              <AnchorLink
     to="/ar/#a-significant-increase-in-states-reaction-rate-in-2020" title="زيادة ملحوظة في نسبة الاستجابة في عام 2020" className="stripped"
     stripHash />
                </li>
              <li>
              <AnchorLink
     to="/ar/#impunity-rate-drops-slightly-2020" title="نسبة الإفلات من العقاب تشهد تراجعاً طفيفاً في عام 2020" className="stripped"
     stripHash />
               </li>
              <li>
              <AnchorLink
     to="/ar/#countries-reporting-on-measures-to-promote-saftety-of-journalists-and-combat-impunity" title="الدول التي أبلغت عن اتخاذ تدابير لتعزيز سلامة الصحفيين ومحاربة الإفلات من العقاب" className="stripped"
     stripHash />
               </li>
              <li>
              <AnchorLink
     to="/ar/#ongoing-issues-in-the-safety-of-journalists" title="قضايا مستمرة متعلقة بسلامة الصحفيين
     " className="stripped"
     stripHash />
                </li>
              <li>
              <AnchorLink
     to="/ar/#key-recent-text-adopted" title="أهم القرارات الصادرة مؤخراً حول سلامة الصحفيين" className="stripped"
     stripHash />
              </li>
            
            </ul>
         </li>
       <li>
           
            <AnchorLink
      to="/ar/#section2" title="جرائم قتل الصحفيين في عامي 2018 و 2019: الاستنتاجات الرئيسية" className="stripped"
      stripHash />
          <span>2</span>
            <div className="clearfix"></div>
            <ul className="submenu"> 
               <li>
               <AnchorLink
      to="/ar/#killing-of-journalists" title="جرائم قتل الصحفيين التي تقع في كل المناطق" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/ar/#type-of-attacks" title="أنواع الاعتداءات" className="stripped"
      stripHash /></li>
               <li> <AnchorLink
      to="/ar/#attacks-against-journalist-are-gendered" title="ارتباط الاعتداءات ضد الصحفيين بالنوع الاجتماعي" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/ar/#gender-dimension-of-safety" title="الأبعاد المتعلقة بالنوع الاجتماعي وعلاقتها بسلامة الصحفيين" className="stripped"
      stripHash /></li>
               <li>
               <AnchorLink
      to="/ar/#tv-journalist-are-most-vunerable-to-attacks" title="صحفيو التلفزيون الأكثر عرضةً لجرائم القتل" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/ar/#local-journalist-remain-targets" title="لا تزال جرائم القتل تستهدف الصحفيين المحليين بشكل رئيسي" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/ar/#freelance-and-staff-journalists" title="الصحفيون المستقلون والعاملون في المؤسسات الإعلامية" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/ar/#most-journalist-were-killed-in-countries-with-no-armed-conflict" title="معظم الضحايا قتلوا في بلدان لا تشهد نزاعات مسلحة" className="stripped"
      stripHash />
             </li>
             </ul>
          </li>

          <li>
           
            <AnchorLink
      to="/ar/#section1" title="الملخص التنفیذي" className="stripped"
      stripHash />
              <span>1</span>
          </li>
       
           </ul>
        <div className="translation-bar">
      <Link to="/">English</Link>
      <Link to="/fr">Français</Link>
      <Link to="/es">Español</Link>
      <Link to="/ru">Русский</Link>
      <Link to="/ar" className="active">العربية</Link>
      <Link to="/zh">中文</Link>
        
      </div>
      </nav>
      
    </header>)
    }
      //Chinese
  if(lang==='zh'){
    return(<header>
    <nav className="mobile-nav-menu" id="mobile-nav-menu">
     <div className="clearfix"> 
    <div className="logo"></div>
    <i className="submenu-state-on" id ="submenu-state" onClick={showMenu}></i>
    </div>
    <ul className="mobile-nav" id="mobile-nav">
          <li>
            <span>1</span>
            <AnchorLink
      to="/zh/#section1" title="执行摘要" className="stripped"
      stripHash />
             
          </li>
          <li>
          
            <span>2</span>
            <AnchorLink
      to="/zh/#section2" title="2018-2019年记者遇害事件:重要发现" className="stripped"
      stripHash />
       <Cavaat gelement="submenu-1"></Cavaat>
            <div className="clearfix"></div>
            <ul className="submenu" id="submenu-1"> 
           
               <li>
               <AnchorLink
      to="/zh/#killing-of-journalists" title="记者遇害事件遍布各个地区" className="stripped"
      stripHash /> <Cavaat gelement="submenu-1"></Cavaat>
                </li>
               <li>
               <AnchorLink
      to="/zh/#type-of-attacks" title="攻击类型" className="stripped"
      stripHash /></li>
               <li> <AnchorLink
      to="/zh/#attacks-against-journalist-are-gendered" title="针对记者的袭击事件中的性别因素" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/zh/#gender-dimension-of-safety" title="安全的性别维度" className="stripped"
      stripHash /></li>
               <li>
               <AnchorLink
      to="/zh/#tv-journalist-are-most-vunerable-to-attacks" title="电视台记者最易遭受致命袭击" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/zh/#local-journalist-remain-targets" title="本地记者仍是主要攻击目标" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/zh/#freelance-and-staff-journalists" title="自由记者与受雇佣记者" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/zh/#most-journalist-were-killed-in-countries-with-no-armed-conflict" title="多数记者在没有发生武装冲突的国家遇害" className="stripped"
      stripHash />
             </li>
             </ul>
          </li>
          <li>
            <span>3</span>
            <a href="/zh/#section3">各国应对措施</a> 
            <Cavaat gelement="submenu-2"></Cavaat>
            <div className="clearfix"></div> 
            <ul className="submenu" id="submenu-2">
           
               <li>
               <AnchorLink
      to="/zh/#overview-of-responses-recieved" title="2020年成员国回应总览" className="stripped"
      stripHash /> <Cavaat gelement="submenu-2"></Cavaat>
              </li>
               <li>
               <AnchorLink
      to="/zh/#a-significant-increase-in-states-reaction-rate-in-2020" title="2020年成员国对总干事请求的回应率大幅上升" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/zh/#impunity-rate-drops-slightly-2020" title="有罪不罚率在2020年略有减少" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/zh/#countries-reporting-on-measures-to-promote-saftety-of-journalists-and-combat-impunity" title="各国就采取措施促进记者安全和打击有罪不罚现象的报告" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/zh/#ongoing-issues-in-the-safety-of-journalists" title="记者安全领域持续面临的问题" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/zh/#key-recent-text-adopted" title="联合国近期通过的关于记者安全问题的重要文件" className="stripped"
      stripHash />
               </li>
             
             </ul>
          </li>
        </ul>
        <div className="clearfix"></div>
        <div className="translation-bar">
      <Link to="/">English</Link>
      <Link to="/fr">Français</Link>
      <Link to="/es">Español</Link>
      <Link to="/ru">Русский</Link>
      <Link to="/ar">العربية</Link>
      <Link to="/zh" className="active">中文</Link>
      </div>
  
    </nav>
  
  
      <nav className="main-nav">
        <div className="logo">
  
        </div>
    
        <ul>
          <li>
            <span>1</span>
            <AnchorLink
      to="/zh/#section1" title="执行摘要" className="stripped"
      stripHash />
             
          </li>
          <li>
            <span>2</span>
            <AnchorLink
      to="/zh/#section2" title="2018-2019年记者遇害事件:重要发现" className="stripped"
      stripHash />
         
            <div className="clearfix"></div>
            <ul className="submenu"> 
               <li>
               <AnchorLink
      to="/zh/#killing-of-journalists" title="记者遇害事件遍布各个地区" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/zh/#type-of-attacks" title="攻击类型" className="stripped"
      stripHash /></li>
               <li> <AnchorLink
      to="/zh/#attacks-against-journalist-are-gendered" title="针对记者的袭击事件中的性别因素" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/zh/#gender-dimension-of-safety" title="安全的性别维度" className="stripped"
      stripHash /></li>
               <li>
               <AnchorLink
      to="/zh/#tv-journalist-are-most-vunerable-to-attacks" title="电视台记者最易遭受致命袭击" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/zh/#local-journalist-remain-targets" title="本地记者仍是主要攻击目标" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/zh/#freelance-and-staff-journalists" title="自由记者与受雇佣记者" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/zh/#most-journalist-were-killed-in-countries-with-no-armed-conflict" title="多数记者在没有发生武装冲突的国家遇害" className="stripped"
      stripHash />
             </li>
             </ul>
          </li>
          <li>
            <span>3</span>
            <a href="/zh/#section3">各国应对措施</a> 
            <div className="clearfix"></div> 
            <ul className="submenu">
               <li>
               <AnchorLink
      to="/zh/#overview-of-responses-recieved" title="2020年成员国回应总览" className="stripped"
      stripHash />
              </li>
               <li>
               <AnchorLink
      to="/zh/#a-significant-increase-in-states-reaction-rate-in-2020" title="2020年成员国对总干事请求的回应率大幅上升" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/zh/#impunity-rate-drops-slightly-2020" title="有罪不罚率在2020年略有减少" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/zh/#countries-reporting-on-measures-to-promote-saftety-of-journalists-and-combat-impunity" title="各国就采取措施促进记者安全和打击有罪不罚现象的报告" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/zh/#ongoing-issues-in-the-safety-of-journalists" title="记者安全领域持续面临的问题" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/zh/#key-recent-text-adopted" title="联合国近期通过的关于记者安全问题的重要文件" className="stripped"
      stripHash />
               </li>
             
             </ul>
          </li>
        </ul>
        <div className="translation-bar">
      <Link to="/">English</Link>
      <Link to="/fr">Français</Link>
      <Link to="/es">Español</Link>
      <Link to="/ru">Русский</Link>
      <Link to="/ar">العربية</Link>
      <Link to="/zh" className="active">中文</Link>
        
      </div>
      </nav>
      
    </header>)
    }
     //Russian
  if(lang==='ru'){
    return(<header>
    <nav className="mobile-nav-menu" id="mobile-nav-menu">
     <div className="clearfix"> 
    <div className="logo"></div>
    <i className="submenu-state-on" id ="submenu-state" onClick={showMenu}></i>
    </div>
    <ul className="mobile-nav" id="mobile-nav">
          <li>
            <span>1</span>
            <AnchorLink
      to="/ru/#section1" title="РЕЗЮМЕ" className="stripped"
      stripHash />
             
          </li>
          <li>
          
            <span>2</span>
            <AnchorLink
      to="/ru/#section2" title="ЖУРНАЛИСТА УБИТЫ В 2018-2019 Г.: КЛЮЧЕВЫЕ РЕЗУЛЬТАТЫ" className="stripped"
      stripHash />
       <Cavaat gelement="submenu-1"></Cavaat>
            <div className="clearfix"></div>
            <ul className="submenu" id="submenu-1"> 
           
               <li>
               <AnchorLink
      to="/ru/#killing-of-journalists" title="УБИЙСТВА ЖУРНАЛИСТОВ ПРОИСХОДЯТ ВО ВСЕХ РЕГИОНАХ ВИДЫ АТАК" className="stripped"
      stripHash /> <Cavaat gelement="submenu-1"></Cavaat>
                </li>
               <li>
               <AnchorLink
      to="/ru/#type-of-attacks" title="Types of Attacks" className="stripped"
      stripHash /></li>
               <li> <AnchorLink
      to="/ru/#attacks-against-journalist-are-gendered" title="АТАКИ ПРОТИВ ЖУРНАЛИСТОВ ГЕНДЕРНЫ" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/ru/#gender-dimension-of-safety" title="ГЕНДЕРНЫЕ АСПЕКТЫ БЕЗОПАСНОСТИ" className="stripped"
      stripHash /></li>
               <li>
               <AnchorLink
      to="/ru/#tv-journalist-are-most-vunerable-to-attacks" title="ТЕЛЕЖУРНАЛИСТЫ НАИБОЛЕЕ УЯЗВИМЫ ДЛЯ СМЕРТЕЛЬНЫХ АТАК" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/ru/#local-journalist-remain-targets" title="МЕСТНЫЕ ЖУРНАЛИСТЫ ОСТАЮТСЯ ЦЕЛЯМИ" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/ru/#freelance-and-staff-journalists" title="ФРИЛАНСЕРЫ И КАДРОВЫЕ ЖУРНАЛИСТЫ" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/ru/#most-journalist-were-killed-in-countries-with-no-armed-conflict" title="БОЛЬШИНСТВО ЖУРНАЛИСТОВ БЫЛО УБИТЫ В СТРАНАХ БЕЗ ВООРУЖЕННОГО КОНФЛИКТА" className="stripped"
      stripHash />
             </li>
             </ul>
          </li>
          <li>
            <span>3</span>
            <a href="/ru/#section3">ГОСУДАРСТВА ОТВЕТИЛИ</a> 
            <Cavaat gelement="submenu-2"></Cavaat>
            <div className="clearfix"></div> 
            <ul className="submenu" id="submenu-2">
           
               <li>
               <AnchorLink
      to="/ru/#overview-of-responses-recieved" title="ОБЗОР ОТВЕТОВ, ПОЛУЧЕННЫХ В 2020 ГОДУ" className="stripped"
      stripHash /> <Cavaat gelement="submenu-2"></Cavaat>
              </li>
               <li>
               <AnchorLink
      to="/ru/#a-significant-increase-in-states-reaction-rate-in-2020" title="ЗНАЧИТЕЛЬНОЕ ПОВЫШЕНИЕ РЕАКЦИИ ГОСУДАРСТВ В 2020 ГОДУ" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/ru/#impunity-rate-drops-slightly-2020" title="УРОВЕНЬ БЕЗНАКАЗАННОСТИ В 2020 ГОДУ СНИЖАЕТСЯ" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/ru/#countries-reporting-on-measures-to-promote-saftety-of-journalists-and-combat-impunity" title="СТРАНЫ, ОТЧИТАВШИЕСЯ О МЕРАХ ПО ОБЕСПЕЧЕНИЮ БЕЗОПАСНОСТИ ЖУРНАЛИСТОВ И БОРЬБЕ С БЕЗНАКАЗАННОСТЬЮ" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/ru/#ongoing-issues-in-the-safety-of-journalists" title="ТЕКУЩИЕ ВОПРОСЫ БЕЗОПАСНОСТИ ЖУРНАЛИСТОВ" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/ru/#key-recent-text-adopted" title="ПОСЛЕДНИЕ ПРИНЯТЫЕ КЛЮЧЕВЫЕ ДОКУМЕНТЫ" className="stripped"
      stripHash />
               </li>
             
             </ul>
          </li>
        </ul>
        <div className="clearfix"></div>
        <div className="translation-bar">
      <Link to="/">English</Link>
      <Link to="/fr">Français</Link>
      <Link to="/es">Español</Link>
      <Link to="/ru" className="active">Русский</Link>
      <Link to="/ar">العربية</Link>
      <Link to="/zh">中文</Link>
      </div>
  
    </nav>
  
  
      <nav className="main-nav">
        <div className="logo">
  
        </div>
    
        <ul>
          <li>
            <span>1</span>
            <AnchorLink
      to="/ru/#section1" title="РЕЗЮМЕ" className="stripped"
      stripHash />
             
          </li>
          <li>
            <span>2</span>
            <AnchorLink
      to="/ru/#section2" title="ЖУРНАЛИСТА УБИТЫ
      В 2018-2019 Г.:
      КЛЮЧЕВЫЕ РЕЗУЛЬТАТЫ" className="stripped"
      stripHash />
         
            <div className="clearfix"></div>
            <ul className="submenu"> 
               <li>
               <AnchorLink
      to="/ru/#killing-of-journalists" title="ЖУРНАЛИСТА УБИТЫ В 2018-2019 Г.: КЛЮЧЕВЫЕ РЕЗУЛЬТАТЫ" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/ru/#type-of-attacks" title="УБИЙСТВА ЖУРНАЛИСТОВ ПРОИСХОДЯТ ВО ВСЕХ РЕГИОНАХ ВИДЫ АТАК" className="stripped"
      stripHash /></li>
               <li> <AnchorLink
      to="/ru/#attacks-against-journalist-are-gendered" title="АТАКИ ПРОТИВ ЖУРНАЛИСТОВ ГЕНДЕРНЫ" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/#gender-dimension-of-safety" title="ГЕНДЕРНЫЕ АСПЕКТЫ БЕЗОПАСНОСТИ" className="stripped"
      stripHash /></li>
               <li>
               <AnchorLink
      to="/ru/#tv-journalist-are-most-vunerable-to-attacks" title="ТЕЛЕЖУРНАЛИСТЫ НАИБОЛЕЕ УЯЗВИМЫ ДЛЯ СМЕРТЕЛЬНЫХ АТАК" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/ru/#local-journalist-remain-targets" title="МЕСТНЫЕ ЖУРНАЛИСТЫ ОСТАЮТСЯ ЦЕЛЯМИ" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/ru/#freelance-and-staff-journalists" title="ФРИЛАНСЕРЫ И КАДРОВЫЕ ЖУРНАЛИСТЫ" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/ru/#most-journalist-were-killed-in-countries-with-no-armed-conflict" title="БОЛЬШИНСТВО ЖУРНАЛИСТОВ БЫЛО УБИТЫ В СТРАНАХ БЕЗ ВООРУЖЕННОГО КОНФЛИКТА" className="stripped"
      stripHash />
             </li>
             </ul>
          </li>
          <li>
            <span>3</span>
            <a href="/ru/#section3">ГОСУДАРСТВА ОТВЕТИЛИ</a> 
            <div className="clearfix"></div> 
            <ul className="submenu">
               <li>
               <AnchorLink
      to="/ru/#overview-of-responses-recieved" title="ОБЗОР ОТВЕТОВ, ПОЛУЧЕННЫХ В 2020 ГОДУ" className="stripped"
      stripHash />
              </li>
               <li>
               <AnchorLink
      to="/ru/#a-significant-increase-in-states-reaction-rate-in-2020" title="ЗНАЧИТЕЛЬНОЕ ПОВЫШЕНИЕ РЕАКЦИИ ГОСУДАРСТВ В 2020 ГОДУ" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/ru/#impunity-rate-drops-slightly-2020" title="УРОВЕНЬ БЕЗНАКАЗАННОСТИ В 2020 ГОДУ СНИЖАЕТСЯ" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/ru/#countries-reporting-on-measures-to-promote-saftety-of-journalists-and-combat-impunity" title="СТРАНЫ, ОТЧИТАВШИЕСЯ О МЕРАХ ПО ОБЕСПЕЧЕНИЮ БЕЗОПАСНОСТИ ЖУРНАЛИСТОВ И БОРЬБЕ С БЕЗНАКАЗАННОСТЬЮ" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/ru/#ongoing-issues-in-the-safety-of-journalists" title="ТЕКУЩИЕ ВОПРОСЫ БЕЗОПАСНОСТИ ЖУРНАЛИСТОВ" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/ru/#key-recent-text-adopted" title="ПОСЛЕДНИЕ ПРИНЯТЫЕ КЛЮЧЕВЫЕ ДОКУМЕНТЫ" className="stripped"
      stripHash />
               </li>
             
             </ul>
          </li>
        </ul>
        <div className="translation-bar">
      <Link to="/">English</Link>
      <Link to="/fr">Français</Link>
      <Link to="/es">Español</Link>
      <Link to="/ru" className="active">Русский</Link>
      <Link to="/ar">العربية</Link>
      <Link to="/zh">中文</Link>
        
      </div>
      </nav>
      
    </header>)
    }
//Spanish Menu
  if(lang==='es'){
    return(<header>
    
    <nav className="mobile-nav-menu" id="mobile-nav-menu">
   <div className="clearfix"> 
  <div className="logo"></div>
  <i className="submenu-state-on" id ="submenu-state" onClick={showMenu}></i>
  </div>
  <ul className="mobile-nav" id="mobile-nav">
 
          <li>
            <span>1</span>
            <AnchorLink
      to="/es/#section1" title="RESUMEN EJECUTIVO" className="stripped"
      stripHash />
             
          </li>
          <li>
            <span>2</span>
            <AnchorLink
      to="/es/#section2" title="ASESINATOS DE PERIODISTAS EN 2018 Y 2019: PRINCIPALES CONCLUSIONES" className="stripped"
      stripHash /><Cavaat gelement="submenu-1"></Cavaat>
         
            <div className="clearfix"></div>
            <ul className="submenu" id="submenu-1"> 
               <li>
               <AnchorLink
      to="/es/#killing-of-journalists" title="LOS ASESINATOS DE PERIODISTAS SE PRODUCEN EN TODAS LAS REGIONES" className="stripped"
      stripHash /><Cavaat gelement="submenu-1"></Cavaat>
                </li>
               <li>
               <AnchorLink
      to="/es/#type-of-attacks" title="TIPOS DE ATAQUES" className="stripped"
      stripHash /></li>
               <li> <AnchorLink
      to="/es/#attacks-against-journalist-are-gendered" title="LAS AGRESIONES CONTRA LOS PERIODISTAS ESTÁN DIFERENCIADAS POR GÉNERO" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/es/#gender-dimension-of-safety" title="DIMENSIONES DE GÉNERO DE LA SEGURIDAD" className="stripped"
      stripHash /></li>
               <li>
               <AnchorLink
      to="/es/#tv-journalist-are-most-vunerable-to-attacks" title="LOS PERIODISTAS DE TELEVISIÓN SON LOS MÁS VULNERABLES A LOS ATAQUES MORTALES" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/es/#local-journalist-remain-targets" title="LOS PERIODISTAS LOCALES SIGUEN SIENDO LOS PRINCIPALES OBJETIVOS" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/es/#freelance-and-staff-journalists" title="PERIODISTAS INDEPENDIENTES Y DE PLANTILLA" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/es/#most-journalist-were-killed-in-countries-with-no-armed-conflict" title="LA MAYORÍA DE LOS PERIODISTAS FUERON ASESINADOS EN PAÍSES SIN CONFLICTOS ARMADOS" className="stripped"
      stripHash />
             </li>
             </ul>
          </li>
          <li>
            <span>3</span>
            <a href="/es/#section3">RESPUESTAS DE LOS ESTADOS</a> <Cavaat gelement="submenu-1"></Cavaat>
            <div className="clearfix"></div> 
            <ul className="submenu" id="submenu-2">
               <li>
               <AnchorLink
      to="/es/#overview-of-responses-recieved" title="SINOPSIS DE LAS RESPUESTAS RECIBIDAS EN 2020" className="stripped"
      stripHash /><Cavaat gelement="submenu-2"></Cavaat>
              </li>
               <li>
               <AnchorLink
      to="/es/#a-significant-increase-in-states-reaction-rate-in-2020" title="AUMENTO SIGNIFICATIVO DE LA TASA DE REACCIÓN DE LOS ESTADOS EN 2020" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/es/#impunity-rate-drops-slightly-2020" title="LA TASA DE IMPUNIDAD DISMINUYE LIGERAMENTE EN 2020" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/es/#countries-reporting-on-measures-to-promote-saftety-of-journalists-and-combat-impunity" title="ACCIONES Y BUENAS PRÁCTICAS COMUNICADAS POR LOS ESTADOS PARA PROMOVER LA SEGURIDAD DE LOS PERIODISTAS Y LUCHAR CONTRA LA IMPUNIDAD" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/es/#ongoing-issues-in-the-safety-of-journalists" title="LOS PROBLEMAS ACTUALES EN LA SEGURIDAD DE LOS PERIODISTAS" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/es/#key-recent-text-adopted" title="TEXTOS CLAVE  ADOPTADOS RECIENTEMENTE" className="stripped"
      stripHash />
               </li>
             
             </ul>
          </li>
        </ul>
      <div className="clearfix"></div>
      <div className="translation-bar">
      <Link to="/">English</Link>
      <Link to="/fr">Français</Link>
      <Link to="/es" className="active">Español</Link>
      <Link to="/ru">Русский</Link>
      <Link to="/ar">العربية</Link>
      <Link to="/zh">中文</Link>
      
    </div>

  </nav>
  
      <nav className="main-nav">
        <div className="logo">
  
        </div>
    
        <ul>
          <li>
            <span>1</span>
            <AnchorLink
      to="/es/#section1" title="RESUMEN EJECUTIVO" className="stripped"
      stripHash />
             
          </li>
          <li>
            <span>2</span>
            <AnchorLink
      to="/es/#section2" title="ASESINATOS DE PERIODISTAS EN 2018 Y 2019: PRINCIPALES CONCLUSIONES" className="stripped"
      stripHash />
         
            <div className="clearfix"></div>
            <ul className="submenu"> 
               <li>
               <AnchorLink
      to="/es/#killing-of-journalists" title="LOS ASESINATOS DE PERIODISTAS SE PRODUCEN EN TODAS LAS REGIONES" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/es/#type-of-attacks" title="TIPOS DE ATAQUES" className="stripped"
      stripHash /></li>
               <li> <AnchorLink
      to="/es/#attacks-against-journalist-are-gendered" title="LAS AGRESIONES CONTRA LOS PERIODISTAS ESTÁN DIFERENCIADAS POR GÉNERO" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/es/#gender-dimension-of-safety" title="DIMENSIONES DE GÉNERO DE LA SEGURIDAD" className="stripped"
      stripHash /></li>
               <li>
               <AnchorLink
      to="/es/#tv-journalist-are-most-vunerable-to-attacks" title="LOS PERIODISTAS DE TELEVISIÓN SON LOS MÁS VULNERABLES A LOS ATAQUES MORTALES" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/es/#local-journalist-remain-targets" title="LOS PERIODISTAS LOCALES SIGUEN SIENDO LOS PRINCIPALES OBJETIVOS" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/es/#freelance-and-staff-journalists" title="PERIODISTAS INDEPENDIENTES Y DE PLANTILLA" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/es/#most-journalist-were-killed-in-countries-with-no-armed-conflict" title="LA MAYORÍA DE LOS PERIODISTAS FUERON ASESINADOS EN PAÍSES SIN CONFLICTOS ARMADOS" className="stripped"
      stripHash />
             </li>
             </ul>
          </li>
          <li>
            <span>3</span>
            <a href="/es/#section3">RESPUESTAS DE LOS ESTADOS</a> 
            <div className="clearfix"></div> 
            <ul className="submenu">
               <li>
               <AnchorLink
      to="/es/#overview-of-responses-recieved" title="SINOPSIS DE LAS RESPUESTAS RECIBIDAS EN 2020" className="stripped"
      stripHash />
              </li>
               <li>
               <AnchorLink
      to="/es/#a-significant-increase-in-states-reaction-rate-in-2020" title="AUMENTO SIGNIFICATIVO DE LA TASA DE REACCIÓN DE LOS ESTADOS EN 2020" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/es/#impunity-rate-drops-slightly-2020" title="LA TASA DE IMPUNIDAD DISMINUYE LIGERAMENTE EN 2020" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/es/#countries-reporting-on-measures-to-promote-saftety-of-journalists-and-combat-impunity" title="ACCIONES Y BUENAS PRÁCTICAS COMUNICADAS POR LOS ESTADOS PARA PROMOVER LA SEGURIDAD DE LOS PERIODISTAS Y LUCHAR CONTRA LA IMPUNIDAD" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/es/#ongoing-issues-in-the-safety-of-journalists" title="LOS PROBLEMAS ACTUALES EN LA SEGURIDAD DE LOS PERIODISTAS" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/es/#key-recent-text-adopted" title="TEXTOS CLAVE  ADOPTADOS RECIENTEMENTE" className="stripped"
      stripHash />
               </li>
             
             </ul>
          </li>
        </ul>
        <div className="translation-bar">
      <Link to="/">English</Link>
      <Link to="/fr">Français</Link>
      <Link to="/es" className="active">Español</Link>
      <Link to="/ru">Русский</Link>
      <Link to="/ar">العربية</Link>
      <Link to="/zh">中文</Link>
      </div>
      </nav>
      
    </header>)
    }

    // Français
  
  if(lang==='fr'){
    return(<header>
      <nav className="mobile-nav-menu" id="mobile-nav-menu">
   <div className="clearfix"> 
  <div className="logo"></div>
  <i className="submenu-state-on" id ="submenu-state" onClick={showMenu}></i>
  </div>
  <ul className="mobile-nav" id="mobile-nav">
 
          <li>
            <span>1</span>
            <AnchorLink
      to="/es/#section1" title="RÉSUMÉ" className="stripped"
      stripHash />
             
          </li>
          <li>
            <span>2</span>
            <AnchorLink
      to="/es/#section2" title="JOURNALISTES TUÉS EN 2018 ET 2019: PRINCIPALES CONCLUSIONS" className="stripped"
      stripHash /><Cavaat gelement="submenu-1"></Cavaat>
         
            <div className="clearfix"></div>
            <ul className="submenu" id="submenu-1"> 
               <li>
               <AnchorLink
      to="/es/#killing-of-journalists" title="DANS TOUTES LES RÉGIONS IL Y A DES MEURTRES DE JOURNALISTES" className="stripped"
      stripHash /><Cavaat gelement="submenu-1"></Cavaat>
                </li>
               <li>
               <AnchorLink
      to="/es/#type-of-attacks" title="TYPES D’ATTAQUES" className="stripped"
      stripHash /></li>
               <li> <AnchorLink
      to="/es/#attacks-against-journalist-are-gendered" title="LES ATTAQUES CONTRE LES JOURNALISTES SONT genrées" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/es/#gender-dimension-of-safety" title="LA DIMENSION DE GENRE DANS LA SÉCURITÉ DES JOURNALISTES" className="stripped"
      stripHash /></li>
               <li>
               <AnchorLink
      to="/es/#tv-journalist-are-most-vunerable-to-attacks" title="LES JOURNALISTES DE TÉLÉVISION SONT LES PLUS VULNÉRABLES AUX ATTAQUES MORTELLES" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/es/#local-journalist-remain-targets" title="LES JOURNALISTES LOCAUX RESTENT LES PRINCIPALES CIBLES" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/es/#freelance-and-staff-journalists" title="JOURNALISTES INDÉPENDANTS ET salariés" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/es/#most-journalist-were-killed-in-countries-with-no-armed-conflict" title="LA PLUPART DES MEURTRES DE JOURNALISTES ONT EU LIEU DANS DES PAYS SANS CONFLIT ARMÉ" className="stripped"
      stripHash />
             </li>
             </ul>
          </li>
          <li>
            <span>3</span>
            <a href="/es/#section3">RÉPONSES DES ÉTATS</a> <Cavaat gelement="submenu-1"></Cavaat>
            <div className="clearfix"></div> 
            <ul className="submenu" id="submenu-2">
               <li>
               <AnchorLink
      to="/es/#overview-of-responses-recieved" title="APERÇU DES RÉPONSES REÇUES EN 2020" className="stripped"
      stripHash /><Cavaat gelement="submenu-2"></Cavaat>
              </li>
               <li>
               <AnchorLink
      to="/es/#a-significant-increase-in-states-reaction-rate-in-2020" title="HAUSSE SIGNIFICATIVE DU TAUX DE RÉPONSE DES ÉTATS EN 2020" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/es/#impunity-rate-drops-slightly-2020" title="LÉGÈRE BAISSE DU TAUX D’IMPUNITÉ EN 2020" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/es/#countries-reporting-on-measures-to-promote-saftety-of-journalists-and-combat-impunity" title="ACTIONS ET BONNES PRATIQUES COMMUNIQUÉES PAR LES ÉTATS VISANT À PROMOUVOIR LA SÉCURITÉ DES JOURNALISTES ET COMBATTRE L’IMPUNITÉ" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/es/#ongoing-issues-in-the-safety-of-journalists" title="QUESTIONS EN COURS EN MATIÈRE DE SÉCURITÉ DES JOURNALISTES" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/es/#key-recent-text-adopted" title="TEXTES CLÉS RÉCENTS SUR LA SÉCURITÉ DES JOURNALISTES" className="stripped"
      stripHash />
               </li>
             
             </ul>
          </li>
        </ul>
      <div className="clearfix"></div>
      <div className="translation-bar">
      <Link to="/">English</Link>
      <Link to="/fr" className="active">Français</Link>
      <Link to="/es">Español</Link>
      <Link to="/ru">Русский</Link>
      <Link to="/ar">العربية</Link>
      <Link to="/zh">中文</Link>
    </div>

  </nav>

      <nav className="main-nav">
        <div className="logo">
  
        </div>
    
        <ul>
          <li>
            <span>1</span>
            <AnchorLink
      to="/fr/#section1" title="RÉSUMÉ" className="stripped"
      stripHash />
             
          </li>
          <li>
            <span>2</span>
            <AnchorLink
      to="/fr/#section2" title="JOURNALISTES TUÉS EN 2018 ET 2019: PRINCIPALES CONCLUSIONS" className="stripped"
      stripHash />
         
            <div className="clearfix"></div>
            <ul className="submenu"> 
               <li>
               <AnchorLink
      to="/fr/#killing-of-journalists" title="DANS TOUTES LES RÉGIONS IL Y A DES MEURTRES DE JOURNALISTES" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/fr/#type-of-attacks" title="TYPES D’ATTAQUES" className="stripped"
      stripHash /></li>
               <li> <AnchorLink
      to="/fr/#attacks-against-journalist-are-gendered" title="LES ATTAQUES CONTRE LES JOURNALISTES SONT genrées" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/fr/#gender-dimension-of-safety" title="LA DIMENSION DE GENRE DANS LA SÉCURITÉ DES JOURNALISTES" className="stripped"
      stripHash /></li>
               <li>
               <AnchorLink
      to="/fr/#tv-journalist-are-most-vunerable-to-attacks" title="LES JOURNALISTES DE TÉLÉVISION SONT LES PLUS VULNÉRABLES AUX ATTAQUES MORTELLES" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/fr/#local-journalist-remain-targets" title="LES JOURNALISTES LOCAUX RESTENT LES PRINCIPALES CIBLES" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/fr/#freelance-and-staff-journalists" title="JOURNALISTES INDÉPENDANTS ET salariés" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/fr/#most-journalist-were-killed-in-countries-with-no-armed-conflict" title="LA PLUPART DES MEURTRES DE JOURNALISTES ONT EU LIEU DANS DES PAYS SANS CONFLIT ARMÉ" className="stripped"
      stripHash />
             </li>
             </ul>
          </li>
          <li>
            <span>3</span>
            <a href="/es/#section3">RÉPONSES DES ÉTATS</a> 
            <div className="clearfix"></div> 
            <ul className="submenu">
               <li>
               <AnchorLink
      to="/fr/#overview-of-responses-recieved" title="APERÇU DES RÉPONSES REÇUES EN 2020" className="stripped"
      stripHash />
              </li>
               <li>
               <AnchorLink
      to="/fr/#a-significant-increase-in-states-reaction-rate-in-2020" title="HAUSSE SIGNIFICATIVE DU TAUX DE RÉPONSE DES ÉTATS EN 2020" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/fr/#impunity-rate-drops-slightly-2020" title="LÉGÈRE BAISSE DU TAUX D’IMPUNITÉ EN 2020" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/fr/#countries-reporting-on-measures-to-promote-saftety-of-journalists-and-combat-impunity" title="ACTIONS ET BONNES PRATIQUES COMMUNIQUÉES PAR LES ÉTATS VISANT À PROMOUVOIR LA SÉCURITÉ DES JOURNALISTES ET COMBATTRE L’IMPUNITÉ" className="stripped"
      stripHash />
                </li>
               <li>
               <AnchorLink
      to="/fr/#ongoing-issues-in-the-safety-of-journalists" title="QUESTIONS EN COURS EN MATIÈRE DE SÉCURITÉ DES JOURNALISTES" className="stripped"
      stripHash />
                 </li>
               <li>
               <AnchorLink
      to="/fr/#key-recent-text-adopted" title="TEXTES CLÉS RÉCENTS SUR LA SÉCURITÉ DES JOURNALISTES" className="stripped"
      stripHash />
               </li>
             
             </ul>
          </li>
        </ul>
        <div className="translation-bar">
      <Link to="/">English</Link>
      <Link to="/fr" className="active">Français</Link>
      <Link to="/es">Español</Link>
      <Link to="/ru">Русский</Link>
      <Link to="/ar">العربية</Link>
      <Link to="/zh">中文</Link>
        
      </div>
      </nav>
      
    </header>)
    }
  
}




Header.propTypes = {
  siteTitle: PropTypes.string,
  lang: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
  lang: `en`,
}

export default Header
